<template>
  <modal
    :title="setModel != undefined ? 'Update Seasons' : 'Add Seasons'"
    @close="$emit('close')"
  >
    <template #content>
      <Form
        method="dialog"
        @submit="onSubmit"
        v-slot="{ errors }"
        class="floating-labels p-1rem"
        ref="form"
      >
        <formGroup
          :title="'Year'"
          type="number"
          v-model.number="model.Year"
          :errors="errors"
          :rules="{ required: true }"
          @keydown.enter="save"
        ></formGroup>
        <formGroup
          :title="'P1'"
          v-model="model.P1"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
        <formGroup
          :title="'P2'"
          v-model="model.P2"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
        <formGroup
          :title="'P3'"
          v-model="model.P3"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </Form>
    </template>
    <template #foot>
      <Btn class="btn-success btn-md" @click="save" :process="process">{{
        setModel != undefined ? "Update Code" : "Add Code"
      }}</Btn>
    </template>
  </modal>
</template>

<script>
export default {
  props: {
    setModel: Object,
    addId: Number,
  },
  data() {
    return {
      model: {
        Id: null,
        HotelId: this.addId,
        Year: null,
        P1: null,
        P2: null,
        P3: null,
      },
      errs: {},
      process: false,
    };
  },
  created() {
    if (this.setModel != undefined) {
      this.model = { ...this.setModel };
    }
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .post(`HotelSeasons`, this.model)
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:
                  this.setModel != undefined
                    ? "The season has been successfully updated."
                    : "The season has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              if (this.setModel != undefined) {
                this.$emit("update", response.data);
              } else {
                this.$emit("add", response.data);
              }
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
